export const selectCategoriesMap = (state) => state.categories.categoriesMap;
export const selectCategoriesLoading = (state) => state.categories.isLoading;
export const selectCategoriesError = (state) => state.categories.error;
